export default [
  {
    path: window.pathApp + '/',
    name: 'autenticacao',
    component: () => import('@/components/Autenticacao'),
    meta: {
      login: false,
      title: "Autenticação",
    }
  },
  {
    path: window.pathApp + '/logoff',
    name: 'logoff',
    component: () => import('@/components/Logoff'),
    meta: {
      login: true,
      title: "Logoff",
    }
  },
  {
      path: "*",
      redirect: window.pathApp + "/",
  }
]



// WEBPACK FOOTER //
// ./src/router/routes/autenticacao.js